import React, { Fragment } from 'react';
import { useMeasure } from 'react-use';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { green500, red500 } from 'styles/colors';
import { injectIntl, intlShape } from 'react-intl';
import withSettings from 'containers/SettingsProvider/withSettings';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts';
import messages from '../messages';

function CombiChart(props) {
  const { data, period, intl, units } = props;
  const [ref, { width }] = useMeasure();

  const title =
    period === 'month' ? intl.formatMessage(messages.monthTitle) : undefined;
  const series = [
    {
      labelProps: { value: units, position: 'insideLeft' },
      Component: Bar,
      componentProps: {
        dataKey: 'distance',
        fill: green500,
        name: intl.formatMessage(messages.distance),
      },
      orientation: 'left',
      yAxisId: 'y1',
    },
    {
      labelProps: {
        value: `${units}/${intl.formatMessage(messages.hr)}`,
        position: 'insideRight',
      },
      Component: Line,
      componentProps: {
        name: intl.formatMessage(messages.speed),
        dataKey: 'speed',
        stroke: red500,
        dot: false,
        connectNulls: true,
      },
      orientation: 'right',
      yAxisId: 'y2',
    },
  ];

  return (
    <div ref={ref} className="my-4">
      <ComposedChart width={width} height={200} barSize={20} data={data}>
        <XAxis dataKey="period" />
        <CartesianGrid strokeDasharray="3 3" />
        {series.map(
          ({ labelProps, Component, orientation, yAxisId, componentProps }) => (
            <Fragment key={yAxisId}>
              <YAxis
                label={{
                  angle: -90,
                  offset: 20,
                  ...labelProps,
                }}
                yAxisId={yAxisId}
                orientation={orientation}
              />
              <Component
                {...componentProps}
                yAxisId={yAxisId}
                animationDuration={250}
              />
            </Fragment>
          ),
        )}
        <Legend />
        <Tooltip animationDuration={250} />
      </ComposedChart>
      {title && <div className="font-italic">{title}</div>}
    </div>
  );
}

CombiChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      period: PropTypes.string,
      distance: PropTypes.number,
      speed: PropTypes.number,
    }),
  ).isRequired,
  units: PropTypes.string.isRequired,
  intl: intlShape,
  period: PropTypes.string,
};

export default compose(
  injectIntl,
  withSettings(['units']),
)(CombiChart);
